var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"showAside pull-left",on:{"click":_vm.toggleClick}},[_c('i',{staticClass:"el-icon-menu"})])])}
var staticRenderFns = []

export { render, staticRenderFns }